import { connect } from 'react-redux'
import ComplexityTreatmentWidget from './ComplexityTreatmentWidget'
import * as selector from '../../../treatment/state/plan/selector'
import * as action from '../../../treatment/state/plan/action'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../state/instance-detail/selector';

const mapStateToProps = (state, props) => {
    const treatmentPlan = selector.selectTreatmentPlan(state)
    const treatmentPlanExists = (typeof treatmentPlan !== 'undefined')

    return {
        treatmentPlanObject: treatmentPlanExists ? selector.selectTreatmentPlan(state) : processSelector.selectProcessContext(state),
        treatmentPlanExists: treatmentPlanExists,
    }
}

const mapDispatchToProps = {
    changeTreatmentPlan: action.changeTreatmentPlan,
    saveTreatmentPlan: action.saveTreatmentPlan,
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ComplexityTreatmentWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/ComplexityTreatmentWidgetContainer.js